module.exports = __webpack_public_path__ + "static/media/logo-YPL.95e8f84e.png";